<template>
  <div class="sb-panel">
    <div class="sb-panel-header">
      <div class="sb-panel-title">
        <span class="sb-panel-icon">
          <slot name="icon" />
        </span>
        <slot name="title" />
        <span v-if="refreshedAt" class="sb-panel-refresh">
          · Last refreshed {{ refreshedAt }}
        </span>
      </div>
      <div class="sb-panel-actions">
        <button class="sb-icon-btn" title="Pin" @click="$emit('pin')">
          <span class="material-icons-outlined">push_pin</span>
        </button>
        <button class="sb-icon-btn" title="Help" @click="$emit('help')">
          <span class="material-icons-outlined">help_outline</span>
        </button>
        <button
          class="sb-icon-btn"
          :title="collapsed ? 'Expand' : 'Collapse'"
          @click="collapsed = !collapsed"
        >
          <span class="material-icons-outlined">{{
            collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up'
          }}</span>
        </button>
      </div>
    </div>
    <transition name="sb-collapse">
      <div v-show="!collapsed" class="sb-panel-body">
        <slot />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'SbPanel',
  props: {
    refreshedAt: { type: String, default: null },
  },
  data: () => ({ collapsed: false }),
};
</script>

<style>
.sb-panel {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 12px;
  overflow: hidden;
}

.sb-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  border-bottom: 1px solid var(--border);
  background: var(--surface);
}

.sb-panel-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 500;
  color: var(--text);
  min-width: 0;
}

.sb-panel-icon .material-icons-outlined {
  font-size: 18px;
  color: var(--text3);
  font-variation-settings: 'wght' 200;
  vertical-align: middle;
}

.sb-panel-refresh {
  font-size: 11px;
  color: var(--text3);
  font-weight: 400;
  white-space: nowrap;
}

.sb-panel-actions {
  display: flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
}

.sb-icon-btn {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border: none;
  background: none;
  color: var(--text3);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s, color 0.15s;
}

.sb-icon-btn:hover {
  background: var(--surface2);
  color: var(--text2);
}

.sb-icon-btn .material-icons-outlined {
  font-size: 18px;
  font-variation-settings: 'wght' 200;
}

.sb-panel-body {
  padding: 0;
}

/* Collapse transition */
.sb-collapse-enter-active,
.sb-collapse-leave-active {
  transition: opacity 0.2s ease;
}

.sb-collapse-enter,
.sb-collapse-leave-to {
  opacity: 0;
}
</style>
